/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as LogoSVG } from '../../assets/icons/ThorneHealthLogo.svg';
import IconCkeck from '../../assets/icons/IconCkeck.svg';
import useStyles from './style';
import Element from '../../components/element';
import { colors } from '../../config/theme';
import PrivacyModal from '../../components/Privacy/privacyModal';
import IconSchedule from '../../assets/icons/IconSchedule.svg';
import IconClockNew from '../../assets/icons/IconClockNew.svg';

import { ReactComponent as IconFamilyHistory } from '../../assets/icons/IconFamilyHistory.svg';
import { ReactComponent as IconSocialHistory } from '../../assets/icons/IconSocialHistory.svg';
import { ReactComponent as IconMedicalHistory } from '../../assets/icons/IconMedicalHistory.svg';
import { ReactComponent as IconAllergiesAndMedication } from '../../assets/icons/IconAllergiesAndMedication.svg';
import { ReactComponent as IconSleepQuality } from '../../assets/icons/IconSleepQuality.svg';
import { ReactComponent as IconPhysicalActivity } from '../../assets/icons/IconPhysicalActivityNew.svg';
import { ReactComponent as IconNutrition } from '../../assets/icons/IconNutrition.svg';
import { ReactComponent as IconMentalHealth } from '../../assets/icons/IconMentalHealth.svg';

import { getActiveAssessments } from '../../root/actions';
import Flex from '../../components/flex';
import Text from '../../components/text';
import { useDispatch, useSelector } from 'react-redux';
import { filter, get, map, size, values } from 'lodash';
import useToast from '../../components/Toast/useToast';

const getReduxData = state => {
  return {
    sortedAssessments: state.containers.app.get('sortedAssessments'),
    user: state.containers.app.get('user')
  };
};

const Sidebar = ({ onSurveyClick, className }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [openSnackbar] = useToast()
  const [modalType, setModalType] = useState('');
  const { sortedAssessments, user } = useSelector(getReduxData);
  const navigate = useNavigate();
  const classes = useStyles();
  const [selectedSurveyIndex, setSelectedSurveyIndex] = useState(-1); // starts with 0
  const [selectedMainIndexValue, setSelectedMainIndex] = useState(0); // starts with 0setSideNavOpen
  const Icons = {
    familyHistory: IconFamilyHistory,
    socialHistory: IconSocialHistory,
    medicalHistory: IconMedicalHistory,
    medications: IconAllergiesAndMedication,
    sleep: IconSleepQuality,
    physicalActivity: IconPhysicalActivity,
    nutrition: IconNutrition,
    mentalHealth: IconMentalHealth
  };
  const SurveyList = [
    {
      data: 'familyHistory',
      value: 0
    },
    {
      data: 'socialHistory',
      value: 1
    },
    {
      data: 'medicalHistory',
      value: 2
    },
    {
      data: 'medications',
      value: 3
    },
    {
      data: 'sleep',
      value: 4
    },
    {
      data: 'physicalActivity',
      value: 5
    },
    {
      data: 'nutrition',
      value: 6
    },
    {
      data: 'mentalHealth',
      value: 7
    }
  ];
  const getIsSurveysCompleted = () => {
    const [completed, total] = getCompletedAndTotalSurveys().split('/');
    return completed === total;
  };

  const onClickScheduleAppointment = () => {
    setSelectedSurveyIndex(-1);
    if (user.dob) {
      if (getIsSurveysCompleted()) {
        navigate('/landing/appointment/view');
      } else {
        navigate('/landing/assessments');
      }
    } else {
      openSnackbar('Please update profile details to proceed with this.', 'warn')
    }
  };

  const onClickPastVisits = () => {
    if (user.dob) {
      navigate('/landing/pastvisits');
    } else {
      openSnackbar('Please update profile details to proceed with this.', 'warn')
    }
  };

  const getCompletedAndTotalSteps = survey => {
    const totalSteps = survey.steps.length;
    const completedSteps =
      filter(survey.steps, step => step.completed).length || '';
    return completedSteps && `${completedSteps}/${totalSteps}`;
  };

  const getCompletedAndTotalSurveys = () => {
    const totalSurveys = size(sortedAssessments);
    const completedSurveys =
      filter(sortedAssessments, assessment => assessment.completed).length ||
      '';
    return `${completedSurveys || 0}/${totalSurveys}`;
    // return '6/8';
  };

  const selectedMainIndex = index => {
    setSelectedMainIndex(index);
  };
  useEffect(() => {
    dispatch(getActiveAssessments({}, {}));
  }, []);

  useEffect(() => {
    if (
      location.pathname.includes('appointment') ||
      location.pathname.includes('assessments')
    ) {
      setSelectedMainIndex(0);
    } else {
      setSelectedMainIndex(1);
    }
    let valueArray = filter(SurveyList, each => {
      return location.pathname.includes(each.data);
    });
    if (valueArray.length > 0) {
      setSelectedSurveyIndex(valueArray[0].value);
    } else {
      setSelectedSurveyIndex(-1);
    }
  }, [location.pathname]);

  return (
    <div className={`${classes.sidebar} ${className}`}>
      <Element>
        <Element textAlign="center" marginTop="30px">
          <Element
            type={LogoSVG}
            onClick={onClickScheduleAppointment}
            cursor="pointer"
            width="180px"
            height="30px"
          />
        </Element>

        <Element onClick={() => selectedMainIndex(0)}>
          <Flex
            align="center"
            marginTop="30px"
            paddingBottom="11px"
            borderBottom={
              selectedMainIndexValue === 0 && `1px solid ${colors.lightGray}`
            }
            className={selectedMainIndexValue === 0 ? '' : classes.iconChange}
          >
            <Element
              type="img"
              attrs={{ src: IconSchedule, onClick: onClickScheduleAppointment }}
              marginRight="15px"
              cursor="pointer"
            // className={`${getIsSurveysCompleted() ? '' : classes.disable}`}
            />
            <Text
              family="GTAM"
              size="16px"
              cursor="pointer"
              onClick={onClickScheduleAppointment}
              color="#222222"
              opacity={selectedMainIndexValue === 0 ? 1 : 0.5}
            // className={`${getIsSurveysCompleted() ? '' : classes.disable}`}
            >
              Schedule a Visit
            </Text>
          </Flex>
        </Element>
        {selectedMainIndexValue === 0 && (
          <Element>
            <Flex
              align="center"
              justify="space-between"
              marginTop="11px"
              paddingBottom="11px"
              borderBottom={`1px solid ${colors.lightGray}`}
            >
              <Text type="h5" family="GTAM" size="16px">
                Pre-Visit Assessments
              </Text>
              <Text
                family="GTAM"
                size="12px"
                color={colors.dustyGray}
                paddingRight="10px"
              >
                {getCompletedAndTotalSurveys()} Completed
              </Text>
            </Flex>
            <div className={classes.sidebarSurveyBody}>
              <ul>
                {map(sortedAssessments, (survey, index) => (
                  <li
                    className={classes.sidebarName}
                    onClick={() => onSurveyClick(survey)}
                    style={{
                      borderRight:
                        selectedSurveyIndex === index
                          ? '4px solid #8b84d7'
                          : '',
                      paddingRight: '10px'
                    }}
                  >
                    <Flex
                      align="center"
                      className={
                        selectedSurveyIndex === index ? '' : classes.iconChange
                      }
                    >
                      <Element
                        type={Icons[survey.shortName]}
                        width="20px"
                        height="20px"
                      />
                      {/* <img
                  src={
                    selectedSurveyIndex === index
                      ? Icons[survey.shortName]
                      : IconsDull[survey.shortName]
                  }
                /> */}
                      <span
                        style={{
                          opacity: selectedSurveyIndex === index ? 1 : 0.7,
                          fontFamily:
                            selectedSurveyIndex === index ? 'GTAM' : 'GTAR'
                        }}
                      >
                        {survey.title === 'Medications'
                          ? 'Allergies and Medication'
                          : survey.title}
                      </span>
                    </Flex>
                    <div>
                      {survey.completed && <img src={IconCkeck} />}
                      {!survey.completed &&
                        getCompletedAndTotalSteps(survey).split('/')[0] !=
                        getCompletedAndTotalSteps(survey).split('/')[1] &&
                        getCompletedAndTotalSteps(survey)}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </Element>
        )}

        <Flex
          align="center"
          marginBottom={selectedMainIndexValue === 1 ? '500px' : '100px'}
          onClick={() => selectedMainIndex(1)}
          className={selectedMainIndexValue === 1 ? '' : classes.iconChange}
        >
          <Element
            type="img"
            attrs={{ src: IconClockNew, onClick: onClickPastVisits }}
            marginRight="15px"
            cursor="pointer"
          />
          <Text
            family="GTAM"
            size="16px"
            cursor="pointer"
            onClick={onClickPastVisits}
            color="#222222"
            opacity={selectedMainIndexValue === 1 ? 1 : 0.5}
          // className={`${getIsSurveysCompleted() ? '' : classes.disable}`}
          >
            Past Visits
          </Text>
        </Flex>
        <Element position="absolute" bottom="20px" left="36px">
          <Element
            fontFamily="GTAR"
            fontSize="12px"
            marginBottom="10px"
            color={colors.dustyGray}
          >
            © Thorne Clinic {new Date().getFullYear()}
          </Element>
          <Element
            fontFamily="GTAR"
            fontSize="12px"
            color={colors.dustyGray}
            cursor="pointer"
          >
            <span onClick={() => setModalType('terms')}>Terms of Service</span>
            ・
            <span onClick={() => setModalType('privacy')}>Privacy Policy</span>
          </Element>
          <br />
          <Element fontFamily="GTAR" fontSize="12px" color={colors.dustyGray}>
            Powered by Thorne Lab
          </Element>
        </Element>
        {modalType && (
          <PrivacyModal
            isPrivacy={modalType === 'privacy'}
            onClose={() => setModalType('')}
          />
        )}
      </Element>
    </div>
  );
};

export default Sidebar;
